import React, { useEffect, useRef } from "react";
import { RCCButton, RCCHookToast, RCCServicesApi, RCCTooltip } from "react-common-components";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import ModalAddChangeDelete from "src/pages/Actions/Panel/components/modalAddChangeDelete";
import { ActionGroupers,IRefActionsPanelModalAddChangeDelete} from "src/pages/Actions/Panel/interface";
import ListOfActions, { IRefListOfActions } from "src/pages/Actions/Panel/listOfActions";
import { standardErrorMessages } from "src/utils/errors";
import { FormMeetingAction } from "../../../interface";
import {IActionTab} from "../interface";

const TabActions: React.FC<IActionTab> = ({
	meetingId,
	formAction
}) => {
	const { translate} = useTranslation();
	const { addToast} = RCCHookToast();
	const { setLoading } = useLoaderBackdrop();
	const isDisable = formAction === FormMeetingAction.VIEW;

	const modalsRef = useRef<IRefActionsPanelModalAddChangeDelete>(null);
	const listOfActionsRef = useRef<IRefListOfActions>(null);

	const onCallbackAdd = async(actionId:number) =>
	{
		try {
			setLoading(true);
			await RCCServicesApi.postRequest({
				method: "Meetings/InsertAction",
				body:{id:meetingId,actionId}
			});

			addToast({
				color: "green",
				description: translate("Ação vinculada com sucesso"),
				title: translate("Sucesso")
			});

			listOfActionsRef.current?.executeQuery();
			setLoading(false);
		} catch (error) {
			standardErrorMessages(error, translate("Erro ao vincular ação à reunião"), addToast);
			setLoading(false);
		}
	};

	useEffect(() => {
		listOfActionsRef.current?.executeQuery();
	}, []);

	return (
		<>
			<ListOfActions 
				ref={listOfActionsRef}
				positionOptions="leftEnd"
				groupersSelect={{
					group: ActionGroupers.MEETING,
					delayed: "",
					origin: ""
				}}
				groupers={{
					grouperId: meetingId
				}}
				layoutList="card"
				header={{
					showTotal: true,
					button: 
						<>
							{!isDisable &&
								<RCCTooltip
									color="purple"
									text={translate("Adicionar ação")}
								>
									<RCCButton
										icon={{name: "plus", color: "#FFF", size: 18}}
										color="purple"
										layout="isRounded"
										size="md"
										onClick={() => modalsRef.current?.openModalAddOrChange(undefined,(id:number) => onCallbackAdd(id))}
									/>
								</RCCTooltip>
							}
						</>
				}}
			/>
			<ModalAddChangeDelete ref={modalsRef} />
		</>	
	);
};

export default TabActions;
